import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";

import { ApiService } from "@core/services";
import { ApiResponse, ChangePasswordRequest, AuthUser, LoginRequest, LoginResponse  } from "@core/types";

const AUTH_API = {
  LOGIN: "/api/auth/login",
  LOGOUT: "/api/auth/logout",
  SEND_RESET_PASSWORD_LINK: "/api/auth/send-reset-password-link",
  RESET_PASSWORD: "/api/auth/reset-password",
  VALIDATE_RESET_PASSWORD: "/api/auth/validate-reset-password",
  CHANGE_PASSWORD: "/api/auth/change-password",
  GET_SESSION: "/api/auth/session",
  SEND_MFA_CODE: "/api/auth/send-mfa-code",
  VERIFY_MFA_CODE: "/api/auth/verify-mfa-code",
};

@Injectable({ providedIn: "root" })
export class AuthService {
  private readonly api = inject(ApiService);

  getSession(): Observable<ApiResponse<AuthUser>> {
    return this.api.get<AuthUser>(AUTH_API.GET_SESSION);
  }

  login(payload: LoginRequest): Observable<ApiResponse<LoginResponse>> {
    return this.api.post<LoginResponse>(AUTH_API.LOGIN, payload);
  }

  logout(): Observable<ApiResponse<void>> {
    return this.api.post<void>(AUTH_API.LOGOUT, {});
  }

  changePassword(payload: ChangePasswordRequest): Observable<ApiResponse<void>> {
    return this.api.post<void>(AUTH_API.CHANGE_PASSWORD, payload);
  }

  resetPassword(payload: ChangePasswordRequest): Observable<ApiResponse<void>> {
    return this.api.post<void>(AUTH_API.RESET_PASSWORD, payload);
  }

  requestPasswordReset(username: string): Observable<ApiResponse<void>> {
    return this.api.post<void>(AUTH_API.SEND_RESET_PASSWORD_LINK, { username });
  }

  validateResetPasswordLink(username: string, token: string): Observable<ApiResponse<void>> {
    return this.api.get<void>(AUTH_API.VALIDATE_RESET_PASSWORD, {
      params: { username, token },
    });
  }

  sendMfaCode(mfaTypeId: number): Observable<ApiResponse<void>> {
    return this.api.post<void>(AUTH_API.SEND_MFA_CODE, { mfaTypeId });
  }

  verifyMfaCode(code: string): Observable<ApiResponse<void>> {
    return this.api.post<void>(AUTH_API.VERIFY_MFA_CODE, { code });
  }
}
